/**
 * Author: Codex Agent
 * Generation: Frontend color mapping utilities (emoji/name/index)
 * Version: v3.2.163
 * Modified: 2025-10-24
 */

// 统一的7色集合（与 CharacterType 数字枚举顺序一致）
export type ColorName = 'green' | 'red' | 'purple' | 'blue' | 'white' | 'black' | 'orange';

const ORDERED_COLORS: ColorName[] = ['green', 'red', 'purple', 'blue', 'white', 'black', 'orange'];

const COLOR_TO_EMOJI: Record<ColorName, string> = {
  green: '🟢',
  red: '🔴',
  purple: '🟣',
  blue: '🔵',
  white: '⚪',
  black: '⚫',
  orange: '🟠'
};

// 历史/外部来源的emoji到颜色映射（🟡 不在资产集中，回退为 orange 以避免缺失）
const EMOJI_TO_COLOR: Record<string, ColorName> = {
  '🟢': 'green',
  '🔴': 'red',
  '🟣': 'purple',
  '🔵': 'blue',
  '⚪': 'white',
  '⚫': 'black',
  '🟠': 'orange',
  '🟡': 'orange'
};

export function emojiToColor(input?: string): ColorName | undefined {
  if (!input) return undefined;
  return EMOJI_TO_COLOR[input] as ColorName | undefined;
}

export function colorToEmoji(color: string | undefined): string | undefined {
  const key = String(color || '').toLowerCase() as ColorName;
  return (COLOR_TO_EMOJI as any)[key];
}

export function normalizeColor(input?: string): ColorName {
  // 优先处理emoji
  const fromEmoji = emojiToColor(input);
  if (fromEmoji) return fromEmoji;
  // 其次处理颜色名
  const lower = String(input || '').toLowerCase();
  if ((ORDERED_COLORS as unknown as string[]).includes(lower)) return lower as ColorName;
  // 默认回退为 green
  return 'green';
}

export function colorToIndex(color: string | undefined): number {
  const name = normalizeColor(color);
  return ORDERED_COLORS.indexOf(name);
}

export function indexToColor(index: number): ColorName {
  const i = Math.max(0, Math.min(ORDERED_COLORS.length - 1, index|0));
  return ORDERED_COLORS[i];
}

export function indexToEmoji(index: number): string {
  return COLOR_TO_EMOJI[indexToColor(index)];
}

